module.exports = __webpack_public_path__ + "img/facebook-icon.83eef348.svg";